module.exports = __webpack_public_path__ + "static/media/hello_world.5497ee72.png";